var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.asset)?_c('div',{class:_vm.className},[_c('div',{staticClass:"u-bleed"},[_c('asset',{staticClass:"b-image-oversized__img",attrs:{"asset":_vm.asset}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }